import { IBriefResource } from "../../briefs";
import { IClassroomResource } from "../../classrooms";
import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IBrief } from "../types";

export type IBriefQueryParameters = {
    brief?: RelationalValue<IBriefResource>;
    classroom?: RelationalValue<IClassroomResource>;
};

export type IBriefQueryResult = IBrief;

export const briefQuery: IApiQueryFunction<IBriefQueryParameters> = ({ brief, classroom }) => {
    if (!brief) {
        return;
    }

    return {
        method: "GET",
        url: `/briefs/${mapRelationalValue(brief)}`,
        headers: classroom ? { "x-classroom-uuid": mapRelationalValue(classroom) } : undefined,
    };
};

export const useBriefQuery = createApiQueryHook<IBriefQueryParameters, IBriefQueryResult>(briefQuery);
